export default __webpack_public_path__ + "static/mini-helix-ps-2-d2dc4e4b3d56a40fe96c874319499f6c.jpg";